import { IAPIService } from '../types'

export default class SectionBase {
  protected service: IAPIService

  constructor(service: IAPIService) {
    this.service = service
  }
}
